import { propertyApiSelectors } from 'modules/api/property'
import { identity } from 'ramda'
import createSelector from 'selectorator'
import { $TSFixMe } from 'types/ts-migrate'
import { NAMESPACE } from '../constants'

// const getState = state => state

export const getReportingState = createSelector([NAMESPACE], identity)
